import XLSX from 'xlsx';

const moment = require('moment');

const headers = [
  'name',
  'numberInProduct',
  'percentageShow',
  'roles',
  'claimed',
  'relatedIncis',
  'numberInPatent',
  'themes',
  'parentSegmentations',
  'subSegmentations',
];
const cols = [
  { width: 25 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
  { width: 15 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
  { width: 50 },
];

export default {
  methods: {
    async exportIngredientView(ingredients, nbProducts) {
      // /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(
        await this.createXLSData(ingredients, nbProducts),
      );

      /* Set worksheet sheet to "wide" */
      ws['!margins'] = {
        left: 1.0,
        right: 1.0,
        top: 1.0,
        bottom: 1.0,
        header: 0.5,
        footer: 0.5,
      };
      ws['!cols'] = cols;

      let i;
      for (i in ws) {
        /* all keys that do not begin with "!" correspond to cell addresses */
        if (i.indexOf('!') === -1) {
          ws[i].s = {
            alignment: {
              wrapText: 1, // any truthy value here
            },
          };
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
      const fileName = `Export vue ingrédient_${moment().format('DD/MM/YYYY')}.xlsx`;
      /* generate file and send to client */
      XLSX.writeFile(wb, fileName);
    },
    async createXLSData(ingredients, nbProducts) {
      try {
        const data = [this.excelHeaders(nbProducts)];

        Object.entries(ingredients).forEach(([name, ingredient]) => {
          data.push([
            name,
            ingredient.numberInProduct,
            Math.round(ingredient.percentageShow * 10000) / 100,
            this.getValuesFromOject(ingredient.roles).join('; '),
            ingredient.claimed,
            this.getValuesFromOject(ingredient.relatedIncis).join('; '),
            ingredient.numberInPatent,
            this.getValuesFromOject(ingredient.themes).join('; '),
            this.getValuesFromOject(ingredient.parentSegmentations).join('; '),
            this.getValuesFromOject(ingredient.subSegmentations).join('; '),
          ]);
        });
        return data;
      } catch (err) {
        console.log(err);
        return null;
      }
    },
    transformObjectToArray(ingredients) {
      const data = [];
      Object.entries(ingredients).forEach(([name, ingredient]) => {
        data.push([
          name,
          ingredient.numberInProduct,
          Math.round(ingredient.percentageShow * 10000) / 100,
          this.getValuesFromOject(ingredient.roles).join('; '),
          ingredient.claimed,
          this.getValuesFromOject(ingredient.relatedIncis).join('; '),
          ingredient.numberInPatent,
          this.getValuesFromOject(ingredient.themes).join('; '),
          this.getValuesFromOject(ingredient.parentSegmentations).join('; '),
          this.getValuesFromOject(ingredient.subSegmentations).join('; '),
        ]);
      });
      return data;
    },
    transformObjectToArrayV2(ingredients) {
      const data = [];
      Object.entries(ingredients).forEach(([name, ingredient]) => {
        data.push([
          name,
          ingredient.numberInProduct,
          Math.round(ingredient.percentageShow * 10000) / 100,
          this.getValuesFromOjectV2(ingredient.roles),
          ingredient.claimed,
          this.getValuesFromOjectV2(ingredient.relatedIncis),
          ingredient.numberInPatent,
          this.getValuesFromOjectV2(ingredient.themes),
          this.getValuesFromOjectV2(ingredient.parentSegmentations),
          this.getValuesFromOjectV2(ingredient.subSegmentations),
        ]);
      });
      return data;
    },
    getValuesFromOject(object) {
      const values = [];
      Object.entries(object).forEach(([name, value]) => {
        values.push(`${name} (${value})`);
      });
      return values;
    },
    getValuesFromOjectV2(object) {
      const values = [];
      Object.entries(object).forEach(([name, value]) => {
        values.push({ name, count: value });
      });
      return values;
    },
    excelHeaders(nbProducts) {
      const headerLabels = [];

      headers.forEach((header) => {
        headerLabels.push(
          header === 'numberInProduct' && nbProducts ? `${this.labels.exportIngredientView[header]} - ${this.labels.export_total_product_selected.replace('%nb%', nbProducts)}` : this.labels.exportIngredientView[header],
        );
      });
      return headerLabels;
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/exportIngredientView.js